import React, {PureComponent} from 'react';
import {withTranslation} from 'react-i18next'

import {toast} from "react-toastify";
import axios from "../../../../axios-defaults";

import {Link} from "react-router-dom";

import Auxiliary from "../../../../hoc/Auxiliary";
import Spinner from "../../../UI/Spinner";
import UserContext from '../../../../context/user-context';

import PaymentPopup from "../../../UI/PaymentPopup";
import AddForm from "./Forms/Add";
import PayForm from "./Forms/Pay";
import Alert from "../../../UI/Alerts/Alert";
import Banks from "../../../Utils/Banks/Banks";
import AcceptedBanks from "../../../Commons/AcceptedBanks";
import logovopay from '../../../../../../public/images/vopay.svg';
import {Modal, Button} from "react-bootstrap";
import {fireGTMPaymentEvent, returnTranslatedPaymentMethod} from "../../../Utils/GTM/GTMHelper";

class List extends PureComponent {
    static contextType = UserContext;

    constructor(props) {
        super(props);

        this.state = {
            can: {
                add: false,
                select: false,
                delete: false,
                pay: false
            },
            loading: false,
            paying: false,
            banks: null,
            selected_bank_id: false,
            error_message: '',
            alert: {},
            show_new_bank_form: false,
            show_saved_bank_list: true,
            amount: 0,

            show_delete_modal:false,
            deleting_bank_id:null

        }

        if (props.can != undefined) {
            this.state.can = {...props.can}
        }
    }

    componentDidMount() {
        this.fetchSavedBanks();
    }

    handleShowDeleteModal = (bank_id,e) => {
        e.stopPropagation();
        this.setState({
            show_delete_modal:true,
            deleting_bank_id:bank_id
        })
    }

    handleCloseDeleteModal = () => {
        this.setState({
            show_delete_modal:false,
            deleting_bank_id:null
        })
    }

    handleNewBankPayment = (type, message) => {
        this.setState({
            show_new_bank_form:false,
            paying: (type !== 'error')
        })
        this.handleShowNewBankForm()
        this.props.handleShowMessage(type, message)
    }

    resetMessages = () => {
        this.setState({
            alert: {},
        });
    }

    handleShowMessage = (type, message) => {
        this.resetMessages();

        if (type == 'error')
            this.setState({alert: {type:'danger',item:{type:'top',text:message}}});
        else if (type == 'warning')
            this.setState({alert: {type:'warning',item:{type:'top',text:message}}});
        else if (type == 'success')
            this.setState({alert: {type:'success',item:{type:'top',text:message}}});

        $('html, body').animate({
            scrollTop: $(".messages").offset().top
        }, 500);
    }

    handleNewBankAdded = (type, message) => {
        this.handleShowMessage(type, message);
        jQuery('.modal-header .close').click()
    }

    deleteBank = () => {
        this.handleCloseDeleteModal();
        this.setState({loading: true})
        if (this.state.can.delete && this.state.deleting_bank_id != null) {
            axios.delete(`/banks/` + this.state.deleting_bank_id)
                .then(response => {
                    if (this.props.handleShowMessage !== undefined)
                        this.props.handleShowMessage('success',this.props.t('saved_banks.messages.delete_success'))
                    else
                        this.handleShowMessage('success',this.props.t('saved_banks.messages.delete_success'))

                    this.fetchSavedBanks();

                })
                .catch(error => {
                    if (this.props.handleShowMessage !== undefined)
                        this.props.handleShowMessage('error',this.props.t('saved_banks.messages.delete_error'))
                    else
                        this.handleShowMessage('error',this.props.t('saved_banks.messages.delete_error'))

                    this.setState({loading: false});
                });
        }
    }

    selectBank = (bank_id) => {
        if (bank_id != this.state.selected_bank_id) {
            this.setState({
                selected_bank_id: bank_id,
                show_new_bank_form: false,
                error_message: ''
            });
        }
    }

    chargeBank = (id) => {
        this.setState({
            loading: true
        })
        this.props.resetMessages()

        axios.post(`/banks/charge`,
            {
                id: id,
                amount: this.props.amount,
                account: this.context.user.account,
                invoices: this.props.invoices,
                paymentOption: this.props.paymentOption
            })
            .then(response => {
                this.setState({loading: false})
                if (response.data.responseMessage !== undefined) {
                    //console.log('/banks/charge no success');
                    this.props.handleShowMessage('error',this.props.t('payment.error_message.general_support'))
                    //this.setState({error_message: response.data.responseMessage})
                } else {
                    //this.setState({error_message: ''})
                    //console.log('/banks/charge success');
                    //console.log('orderId: '+response.data.orderId);
                    //console.log('bank_data used:');
                    //console.log(response.data.bank_data);
                    this.props.handleShowMessage('confirmation',response.data.orderId)
                    this.props.setBankUsed(response.data.bank_data)
					const invoicesCount = this.props.invoices.length;
					const invoicesTotal = this.props.amount;
					fireGTMPaymentEvent('3_succes', {mode : returnTranslatedPaymentMethod(this.props.paymentOption), type : `banque-sauvegarde`, invoicesCount, invoicesTotal});

				}
            })
            .catch(error => {
                console.log('/banks/charge error');
				fireGTMPaymentEvent('9_echoue', {mode : returnTranslatedPaymentMethod(this.props.paymentOption), type : `banque-sauvegarde`});
				this.props.handleShowMessage('error',this.props.t('payment.error_message.general_support'))
            });
    }

    handleShowNewBankForm = () => {
        this.setState({
            show_new_bank_form: true,
            show_saved_bank_list: false,
            selected_bank_id: null
        });
    }

    handleShowBanksList = () => {
        this.setState({
            show_new_bank_form: false,
            show_saved_bank_list: true,
            selected_bank_id: null
        });
    }

    fetchSavedBanks = () => {
        this.setState({
            loading: true
        });
        axios.get(`/banks`)
            .then(response => {
                this.setState({
                    banks: response.data,
                    loading: false,
                    show_new_bank_form:response.data.length==0
                });
            }).catch(error => {
            toast.error(
                <div>
                    <i className="fal fa-exclamation-circle"></i>&nbsp;{this.props.t('errors.error')}
                </div>
            );
        });
    }

    render() {
        const {
            can,
            banks,
            loading,
            paying,
            selected_bank_id,
            error_message,
            show_new_bank_form,
            show_saved_bank_list,
            alert,
            show_delete_modal
        } = this.state;

        const {user} = this.context;
        const {t, hideSavedBanks} = this.props;
        const from = this.props.from
        let dataHtml = '';


        if (loading) {
            dataHtml = (
                <Spinner/>
            );
        } else {
            if (Array.isArray(banks) && banks.length > 0 && !hideSavedBanks) {
                dataHtml = (
                    <Auxiliary>
                        <div className={`creditcards creditcards--` + from}>
                            {banks.map((bank, index) => {
                                return (
                                    <div className="" key={index}>
                                        <div className={`creditcard ${selected_bank_id == bank.id ? 'selected':'' }`}
                                              onClick={ can.select ? () => this.selectBank(bank.id) : null
                                        } >

                                            {selected_bank_id == bank.id && error_message != '' ?
                                                <p className={'p--c-red'}>{error_message}</p>
                                                : null
                                            }


                                                    <div className="creditcard__infos">
                                                    <div className="col-sm-5">
                                                        <div className="creditcard__infos__label">
                                                            {t('savedbanks.details')}
                                                        </div>
                                                        <div className="creditcard__infos__value">
                                                            <Banks type={bank.bank_type} />
                                                            {' '}{t('savedbanks.endingby')}{' '}{bank.bank_account_number.substr(bank.bank_account_number.length -4)}
                                                        </div>
                                                    </div>
                                                        <div className="col-7 col-sm-3">
                                                            <div className="creditcard__infos__label">
                                                                {t('savedbanks.institution')}
                                                            </div>
                                                            <div className="creditcard__infos__value">
                                                               {bank.institution}
                                                            </div>
                                                        </div>
                                                        <div className="col-5 col-sm-2">

                                                        </div>
                                                        <div className="col-sm-2 a-right col-delete">
                                                            {can.delete ?
                                                                <Link to={'#'} onClick={(e) => this.handleShowDeleteModal(bank.id,e)} title={t('savedbanks.delete')}
                                                                      className="link link--accent link--red link--fs-14"><i
                                                                    className="fas fa-minus-circle"></i>&nbsp;
                                                                    <span className="link__text">{t('savedbanks.delete')}</span>
                                                                </Link>
                                                                : null}
                                                        </div>

                                                    </div>




                                                {(selected_bank_id == bank.id && can.select) ?
                                                    <div className="creditcard__payment">
                                                        <div className="w-100">
                                                            <button className="btn btn--raised btn--raised--red btn--fs-12"
                                                                    onClick={() => this.chargeBank(bank.id)}>
                                                                <b>{t('savedbanks.pay')}&nbsp;&nbsp;<i
                                                                    className="fas fa-angle-right"></i></b>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    :
                                                    null}

                                        </div>

                                    </div>
                                );
                            })}
                        </div>

                    </Auxiliary>
                );
            } else {
                {can.add ?
                    dataHtml = (<p className="no-result">{t('savedbanks.noresults')}</p>)
                    :
                    dataHtml = ''}
            }
        }

        return (
            <div className="saved-cards">
                {paying ?
                    <Spinner/>
                    :
                    <div className="saved-cards__main">
                        <div className="saved-cards__heading">
                            {can.add && alert != {} ?
                                <div>
                                    <div className={"messages"}>
                                        <Alert type={alert.type} item={alert.item} />
                                    </div>
                                </div>
                                :null}

                            {Array.isArray(banks) && banks.length > 0 && !hideSavedBanks ?
                                <Auxiliary>
                                    {  from === 'popup' ?
                                        <Auxiliary>
                                            <h3 className="headline headline--block headline--uppercase">
                                                {t("savedbanks.paysavedbank")} ({banks.length})
                                            </h3>
                                        </Auxiliary>
                                    :
                                    <h3 className="headline headline--section headline--uppercase">{t("profile.banks")}</h3>
                                }
                                </Auxiliary>
                            :
                                <h3 className="headline headline--section headline--uppercase">
                                    {  from === 'popup' ? t("popup.payment_title") : t("profile.banks") }
                                </h3>
                            }

                            <AcceptedBanks />
                        </div>
                        <div className="saved-cards__body">
                            {dataHtml}
                        </div>
                        <div className="saved-cards__actions">
                            {can.add ?
                                <PaymentPopup
                                    btn_title={t("popup.addbank")}
                                    modal_title={t("popup.addbank")}
                                    modal_func={'add_bank'}
                                    customer_data={'payer_reference_number'}
                                    modal_content={
                                        <div>
                                            <AddForm
                                                refreshBanksList={this.fetchSavedBanks}
                                                handleNewBankAdded={this.handleNewBankAdded}
                                                closePopup={() => {$('.modal-header .close').click()}}
                                            />
                                        </div>
                                    }
                                /> :
                                null}

                            {can.pay ?
                                <div>
                                    {banks != null && banks.length > 0 ?
                                        <Link to={'#'} onClick={this.handleShowNewBankForm}
                                              className="btn btn--outline w-100">{t('savedbanks.paynewbank')}&nbsp;&nbsp;<i
                                            className="far fa-plus"></i></Link>: null}
                                    {show_new_bank_form ?
                                        <PayForm
                                            amount={this.props.amount}
                                            invoices={this.props.invoices}
                                            paymentOption={this.props.paymentOption}
                                            refreshBanksList={this.fetchSavedBanks}
                                            handleShowMessage={this.props.handleShowMessage}
                                            resetMessages={this.props.resetMessages}
                                            setBankUsed={this.props.setBankUsed}
                                        /> : null}
                                </div>
                                : null
                            }
                            <div className={"vopay-secure"}>
                                <i className="far fa-lock"/>&nbsp;&nbsp;{t('savedbanks.paymentsecure')}&nbsp;&nbsp;<img src={logovopay} alt={"vopay"} title={t('savedbanks.paymentsecurevopay')}/>
                            </div>
                        </div>
                    </div>
                }

                <Modal
                    show={show_delete_modal}
                    animation={false}
                    className="confirmation-modal"
                    onHide={this.handleCloseDeleteModal}
                >
                    <div className="popup-content">
                        <div className="popup-delete">
                            <div className="content">{t('savedbanks.delete_modal.content')}</div>
                            <div className="actions">
                                <button  className="btn btn-primary btn-sm"   onClick={this.handleCloseDeleteModal}>
                                    {t('savedbanks.delete_modal.cancelbtn')}
                                </button>
                                <button  className="btn btn-secondary btn-sm" onClick={this.deleteBank}>
                                    {t('savedbanks.delete_modal.actionbtn')}
                                </button>
                            </div>
                        </div>
                    </div>

                </Modal>
            </div>

        );

    }
}

export default withTranslation()(List);
